export const CSAT_NPS = {
  STORAGE_KEY: 'csat_nps',
  TRIGGER_NAME: 'csat_nps',
  MIN_VISITED_ADS: 2
}
